const CHATBOT_REQUEST_TYPE = 'chatbot'

/**
 * Mirrors `Request::getChatbotInteractionType()` so Office names the chat flow the same way
 * the widget and the pro dashboard do.
 */
const INTERACTION_TYPE_BY_SOURCE: Record<string, string> = {
    'chatbot-callback': 'callback',
    'chatbot-quote': 'quote',
    'chatbot-appointment': 'appointment',
    'chatbot-message': 'message',
}

/**
 * A lead from the provider's own embedded conversion chatbot, rather than from the
 * marketplace. Gated on the request type because the profile chatbot on trustoo.nl writes
 * the same `chatbot-*` sources for regular marketplace leads.
 *
 * @see \Api\Model\Entity\Request::isChatbotConversionLead()
 */
export const isChatbotLead = (requestType?: string | null): boolean =>
    requestType === CHATBOT_REQUEST_TYPE

/**
 * Short label for a chatbot lead, including the chat flow when the source is recognised
 * (e.g. "Chatbot · quote").
 */
export const getChatbotLeadLabel = (source?: string | null): string => {
    const interactionType = source ? INTERACTION_TYPE_BY_SOURCE[source] : undefined

    return interactionType ? `Chatbot · ${interactionType}` : 'Chatbot'
}

/**
 * Colour of the chatbot marker, pinned to the pro dashboard's chatbot label so a lead reads
 * the same in Office as it does in the pro's own inbox.
 */
export const CHATBOT_LEAD_COLOR = '#317bff'
